import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { Button } from '@/components/ui/button';

import { HorizontalLayout, VerticalLayout } from './Layout';
import { Text } from './Text';

export const SaveBar = () => {
    const {
        reset,
        formState: { dirtyFields, errors },
    } = useFormContext();

    const numberOfChangedProperties = Object.keys(dirtyFields).length;
    const hasErrors = Object.keys(errors).length > 0;

    if (!numberOfChangedProperties) {
        return null;
    }
    return (
        <>
            <Bar $gap={16}>
                <VerticalLayout>
                    <Text>You have {numberOfChangedProperties} unsaved change(s)</Text>
                    <Text $themeColor="negative">{hasErrors ? 'Invalid form values' : ''}</Text>
                </VerticalLayout>
                <Button variant="outline" type="button" size="sm" onClick={() => reset()}>
                    Cancel
                </Button>
                <Button variant="default" type="submit" size="sm" disabled={hasErrors}>
                    Save
                </Button>
            </Bar>
        </>
    );
};

const Bar = styled(HorizontalLayout)`
    position: fixed;
    bottom: 0;
    left: 65px;
    width: calc(100% - 65px);
    padding: 16px;
    align-items: center;
    justify-content: center;
    border-top: 1px solid ${({ theme }) => theme.border.light};
    height: 60px;
    background-color: ${({ theme }) => theme.container.primaryBackground};
    z-index: 10;
`;
